"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminSchoolViewController = /** @class */ (function () {
    function AdminSchoolViewController($scope, UserService, school) {
        this.user = UserService.getCurrentUser();
        this.school = school;
        this.locations = this.school.locations;
        this.center = {
            lat: this.locations[0].address.lat,
            lng: this.locations[0].address.lng,
            zoom: 2,
        };
    }
    return AdminSchoolViewController;
}());
AdminSchoolViewController.$inject = ["$scope", "UserService", "school"];
exports.default = AdminSchoolViewController;
